import isServer from "@/_base/isServer";
import axios from "axios";
import https from "https";

const config = {
	baseURL: process.env.VUE_APP_API_BASE_URL,
	loadingDuration: 1200,
}

const storage = isServer ? axios.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false }) : require("vue3-storage").useStorage("oright_");

const errorProcess = ({ error, vueApp }) => {
	const $swal = vueApp.config.globalProperties.$swal;
	const alertOptions = {
		title: `status: ${error.response ? error.response.status : error.name}`,
		text: error.response ? JSON.stringify(error.response.data.message) : error.message,
		icon: "error",
		allowOutsideClick: false,
		allowEscapeKey: false,
		didOpen: () => {
			$swal.hideLoading();
		},
	}

	const errorProcesses = {
		tokenError: {
			title: "登入token錯誤，請重新登入。",
			didClose: () => {
				vueApp.config.globalProperties.$store.commit("headerStore/setLoggedIn", false);
				vueApp.config.globalProperties.$router.push("/member/login");
			},
		},
		tokenExpired: {
			title: "登入過期，請重新登入。",
			icon: "warning",
			didClose: () => {
				vueApp.config.globalProperties.$store.commit("headerStore/setLoggedIn", false);
				vueApp.config.globalProperties.$router.push("/member/login");
			},
		},
		// 訪客免 OTP 完成註冊時，帳號已非訪客（多為已轉正/重複送出）→ /api/guest/register 回 403 'not a guest account'
		alreadyMember: {
			title: "此帳號已是會員",
			text: "您已完成註冊，請直接登入。",
			icon: "info",
			didClose: () => {
				vueApp.config.globalProperties.$store.commit("headerStore/setLoggedIn", false);
				vueApp.config.globalProperties.$router.push("/member/login");
			},
		},
		// 後端頻率限制（HTTP 429）：顯示後端給的中文訊息，取代「status: 429」
		tooManyAttempts: {
			title: (error.response && error.response.data && error.response.data.text) || "操作過於頻繁，請稍後再試",
			text: "",
			icon: "warning",
		},
		// 換手機驗證碼通過後，號碼已被會員或有效訂單訪客持有（HTTP 409，guest-account-release）
		phoneTaken: {
			title: "手機號碼已經被註冊",
			text: "",
			icon: "warning",
		},
		// 換手機驗證碼通過後，號碼仍在無成交訪客的等待期內（HTTP 409）
		phoneRecentlyUsed: {
			title: "此手機號碼暫時無法變更，請稍後再試。",
			text: "",
			icon: "warning",
		},
		// 訪客結帳驗證時，同一支手機正被其他流程處理（HTTP 409，極少見）
		phoneBusy: {
			title: "系統忙碌中，請稍後再試",
			text: "",
			icon: "warning",
		},
		// 訪客結帳 token 對應的帳號手機已被釋放（orders/create 422）；Step2 會重設驗證狀態
		guestPhoneReleased: {
			title: "手機驗證已失效，請重新驗證手機",
			text: "",
			icon: "warning",
		},
	}

	let processKey;
	if (error.response) {
		switch (error.response.data.message) {
			case "The token has been blacklisted":
			case "Token Signature could not be verified.":
				processKey = "tokenError";
				break;

			case "Token has expired and can no longer be refreshed":
				processKey = "tokenExpired";
				break;

			case "not a guest account":
				processKey = "alreadyMember";
				break;

			case "too_many_attempts":
				processKey = "tooManyAttempts";
				break;

			case "phone_taken":
				processKey = "phoneTaken";
				break;

			case "phone_recently_used":
				processKey = "phoneRecentlyUsed";
				break;

			case "phone_busy":
				processKey = "phoneBusy";
				break;

			case "guest_phone_released":
				processKey = "guestPhoneReleased";
				break;

			default:
				break;
		}
	}
	return $swal.fire(processKey ? Object.assign(alertOptions, errorProcesses[processKey]) : alertOptions);
}

const setToken = (token) => {
	if (token && storage && !isServer) {
		storage.setStorageSync("token", token);
	}
}

const sendToken = (headers) => {
	if (headers && storage && !isServer) {
		// 若呼叫端已明確帶入 Authorization（例如訪客結帳專用 token），不要用登入 token 覆蓋
		if (headers.Authorization) {
			return;
		}
		const token = storage.getStorageSync("token");
		if (token) {
			headers.Authorization = token;
		}
	}
}


const updatedCartIdAndBucketId = (data) => {
	if (data.user_id || data.cart_id) {
		let cartId = data.user_id || data.cart_id;
		if (storage && !isServer) {
			storage.setStorageSync("cartId", String(cartId));
		}
	}
	if (data.user_id || data.bucket_id) {
		let bucket_id = data.user_id || data.bucket_id;
		if (storage && !isServer) {
			storage.setStorageSync("bucketId", String(bucket_id));
		}
	}
}

const createAxiosInstance = (vueApp) => {
	const $swal = vueApp.config.globalProperties.$swal;
	const instance = axios.create(config);

	instance.interceptors.request.use(
		(config) => {
			const usedBaseURL = !/(http(s?)):\/\//i.test(config.url) || config.url.startsWith(process.env.VUE_APP_API_BASE_URL);
			if (usedBaseURL) {
				sendToken(config.headers);
			}
			if (config.loading) {
				config.startTime = performance.now();
				config.loadingAlert = $swal.fire({
					title: "請稍候",
					allowOutsideClick: false,
					allowEscapeKey: false,
					didOpen: () => {
						$swal.showLoading();
					}
				});
			}
			return config;
		},
		(error) => {
			console.error(error);
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		async (response) => {
			setToken(response.headers.authorization || response.config.headers.token);
			updatedCartIdAndBucketId(response.data);
if (response.config.middleCall instanceof Function) {
				response.middleData = await response.config.middleCall();
			}
			if (response.config.loading) {
				response.duration = performance.now() - response.config.startTime;
				if (response.duration < response.config.loadingDuration) {
					await new Promise((resolve) => {
						setTimeout(() => {
							resolve();
							response.config.loadingAlert.close();
						}, response.config.loadingDuration - response.duration);
					});
				} else {
					await response.config.loadingAlert.close();
				}
			}
			return response;
		},
		async (error) => {
			if (isServer) {
				throw Error(`on server prefetch fail: ${error.config.baseURL}${error.config.url}`);
			}
			await errorProcess({ error, vueApp });
			return Promise.reject(error);
		}
	);

	return instance;
}

const $axios = {
	install(Vue, options) {
		Vue.config.globalProperties.axios = createAxiosInstance(Vue);
	}
}
export default $axios;